import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { industriesData } from '../data/mock';
import { Car, Heart, Activity, Smartphone, Settings, Bot, Rocket, Shield, Package, ShoppingCart, GraduationCap, Wifi } from 'lucide-react';

const iconMap = {
  Car, Heart, Activity, Smartphone, Settings, Bot, Rocket, Shield, Package, ShoppingCart, GraduationCap, Wifi
};

export default function Industries() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  return (
    <section ref={ref} className="relative py-32 overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#1E3A6F]/5 via-transparent to-[#2A4A85]/5" />

      <div className="container mx-auto px-6 relative z-10">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-20"
        >
          <div className="text-[#6B8FCC]/60 font-mono text-sm mb-4">INDUSTRIES</div>
          <h2 className="text-5xl md:text-7xl font-black mb-6 bg-gradient-to-r from-white via-[#B8CDE8] to-white bg-clip-text text-transparent">
            Industries We Serve
          </h2>
        </motion.div>

        {/* Industries Grid */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.8, staggerChildren: 0.1 }}
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-6xl mx-auto"
        >
          {industriesData.map((industry, index) => {
            const Icon = iconMap[industry.icon];
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.6, delay: index * 0.05 }}
                className="group relative"
              >
                <div className="relative p-6 rounded-2xl bg-white/5 backdrop-blur-xl border border-white/10 hover:border-[#4A6FA5]/50 transition-all duration-500 hover:scale-105 cursor-pointer text-center">
                  {/* Icon Container */}
                  <div className="w-16 h-16 mx-auto mb-4 rounded-xl bg-gradient-to-br from-[#1E3A6F]/20 to-[#2A4A85]/20 flex items-center justify-center group-hover:scale-110 group-hover:rotate-12 transition-all duration-500 border border-[#4A6FA5]/30">
                    <Icon className="w-8 h-8 text-[#4A6FA5]" />
                  </div>

                  {/* Industry Name */}
                  <h3 className="text-sm font-semibold text-white group-hover:text-[#4A6FA5] transition-colors">
                    {industry.name}
                  </h3>

                  {/* Hover Effect */}
                  <div className="absolute inset-0 bg-gradient-to-br from-[#1E3A6F]/0 to-[#2A4A85]/0 group-hover:from-[#1E3A6F]/10 group-hover:to-[#2A4A85]/10 rounded-2xl transition-all duration-500 pointer-events-none" />
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
